import React from 'react';

const CloseIcon = ({ className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none"
      className={`text-v3-black-max ${className}`}
      {...props}
    >
      <path 
        d="M19 5L6 19M6 5L19 19" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CloseIcon;
